import './FormAction.css';
import ActionType from '../../../data/constant/types/ActionType';
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import TitleBlock from '../TitleBlock/TitleBlock';
import BlockList from '../../../data/constant/BlocksList';
import NiceModal from '@ebay/nice-modal-react';
import FormList from '../FormList';
import useBlock from '../../../hook/block/useBlock';
import editorAction from '../../../actions/editorAction';
import { useTreeStateContext } from '../../../contexts/TreeContext';


// This form allow user to change the type of block action, thath action cannot be reverted
function FormAction( { name, id }) {

    const actions = Object.entries(ActionType)
        .filter(([key]) => key !== 'categorization')
        .map(([key, value]) => { return { text : value, value : key } });

    const { updateBlockAction } = useBlock()
    const { checkErrors } = editorAction();
    const { blocks, paths, children } = useTreeStateContext();

    const defaultAction = actions.pop();

    const setValueDropdown = (name, value) => {
        const effectiveValue = value === 'keyword_redirection' ? 'categorization' : value;
        const block = BlockList[effectiveValue];
        const Component = FormList[effectiveValue];
        const res = updateBlockAction(id, block);

        const freshChildren = [...children.filter((c) => c.parent_block_id !== id), ...(res.children || [])];
        const freshBlocks = blocks.map((b) => (b.object_id === id
            ? { ...b, name: res.name, action_type: res.action_type, type: res.type, data: res.data, children: res.children }
            : b));
        checkErrors(freshBlocks, paths, freshChildren);

        NiceModal.show('editor-window', { Component,  componentProps : {name : res.name, id} });
    }
    
    return (
        <>
            <TitleBlock title="Action" titleInput="Action name" name={name} id={id}/>
            <div className='area-edit'>
                <label className="input_title">Action type</label>
                <Dropdown choices={actions} placeholder={defaultAction.text} width="calc(100%)" name="action_type" setValue={setValueDropdown}/>
            </div>
        </>
    )
}

export default FormAction;